import React from 'react';
import { Box, Grid, TextField } from '@mui/material';
import { CreatableSelect } from 'components/campaigns/CreatableSelect';
import { AwardTemplate } from 'components/customers/models/Award';
import { Perk } from 'components/loyalty/models/PerkModel';
import { Option } from 'lib/types';

interface PerkEffectProps {
    value: Option;
    onChange: (value: Option) => void;
    onCreate: (title: string) => void;
    perks: Perk[];
    remove?: boolean;
    points?: string;
    onPointsChange?: (e: { target: { value: string } }) => void;
}

const findPerk = (perks: Perk[], perkId: string) => perks.find(item => item._id === perkId);

export const PerkEffect: React.FC<PerkEffectProps> = ({
    value,
    onChange,
    onCreate,
    perks,
    remove,
    points,
    onPointsChange
}) => {
    const currentPerk = React.useMemo(() => findPerk(perks, value && value.value), [value, perks]);
    const stampPerk = React.useMemo(
        () => currentPerk && !remove && currentPerk.template === AwardTemplate.STAMP_CARD,
        [currentPerk, remove]
    );
    const options = React.useMemo(() => perks.map(item => ({ label: item.title, value: item._id })), [perks]);
    return (
        <React.Fragment>
            <Grid item>
                <Box minWidth={300}>
                    <CreatableSelect
                        placeholder={'Select perk or start typing...'}
                        value={value}
                        onChange={onChange}
                        options={options}
                        onCreate={onCreate}
                    />
                </Box>
            </Grid>
            {stampPerk && (
                <Grid item>
                    <Box minWidth={80}>
                        <TextField
                            value={points}
                            type="number"
                            inputProps={{ min: 0 }}
                            onChange={onPointsChange}
                            placeholder="Stamps"
                        />
                    </Box>
                </Grid>
            )}
        </React.Fragment>
    );
};
